var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 154,
    fill: "#F4F2F9",
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5596 108.763C41.5596 89.8267 57.13 77.2013 77.0001 77.2013C96.635 77.2013 112.441 89.8357 112.441 108.763H105.233C105.233 101.27 102.478 95.9509 97.3892 91.7495C92.2917 87.541 84.8915 84.0586 77.0001 84.0586C68.9835 84.0586 62.0607 87.5423 56.8335 91.7535C51.6155 95.9573 48.7667 101.276 48.7667 108.763H41.5596Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0001 73.4709C86.7456 73.4709 94.6459 65.5706 94.6459 55.825C94.6459 46.0795 86.7456 38.1792 77.0001 38.1792C67.2545 38.1792 59.3542 46.0795 59.3542 55.825C59.3542 65.5706 67.2545 73.4709 77.0001 73.4709ZM77.0001 66.4125C82.8474 66.4125 87.5876 61.6723 87.5876 55.825C87.5876 49.9777 82.8474 45.2375 77.0001 45.2375C71.1528 45.2375 66.4126 49.9777 66.4126 55.825C66.4126 61.6723 71.1528 66.4125 77.0001 66.4125Z",
    fill: "black",
    fillOpacity: 0.16
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/default-user.7b7fe2065aed7aee35246afc8b9b7894.svg";
export { ForwardRef as ReactComponent };